import moment from 'moment';

import templateUrl from './rogers-owner-daily-production-report.component.html';

export const RogersOwnerDailyProductionReportComponent = {
    controller: RogersOwnerDailyProductionReportController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        report: "<"
    }
};

function RogersOwnerDailyProductionReportController() {
    const vm = this;
    vm.today = moment().startOf("day");
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
        if (vm.report && vm.report.CurrentWeekStatus) {
            calculateStatusTotals(vm.report.CurrentWeekStatus);
        }
        if (vm.report && vm.report.PreviousWeekStatus) {
            calculateStatusTotals(vm.report.PreviousWeekStatus);
        }
    }

    function onChanges() {
        if (vm.report && vm.report.CurrentWeekStatus) {
            calculateStatusTotals(vm.report.CurrentWeekStatus);
        }
        if (vm.report && vm.report.PreviousWeekStatus) {
            calculateStatusTotals(vm.report.PreviousWeekStatus);
        }
    }

    function calculateStatusTotals(weekStatus) {
        const baseTotals = {
            BookedCount: 0,
            CancelledCount: 0,
            ConfirmedCount: 0,
            ShmCount: 0,
            WirelessCount: 0,
            MigrationCount: 0,
            DisconnectCount: 0
        };
        weekStatus.totals = weekStatus.DailyStatuses.reduce(function (totals, status) {
            totals.BookedCount += status.BookedCount;
            totals.CancelledCount += status.CancelledCount;
            totals.ConfirmedCount += status.ConfirmedCount;
            totals.ShmCount += status.ShmCount;
            totals.WirelessCount += status.WirelessCount;
            totals.MigrationCount += status.MigrationCount;
            totals.DisconnectCount += status.DisconnectCount;
            return totals;
        }, baseTotals);
    }
}
